import type { InputHTMLAttributes } from 'react';
import { cn } from '../../../helpers/commonUtils';
import styles from './TextField.module.css';

export type TextFieldProps = InputHTMLAttributes<HTMLInputElement> & {
    wrapperClassName?: string;
};

export function TextField({ wrapperClassName, className, type = 'search', ...props }: TextFieldProps) {
    return (
        <div className={cn(styles.wrap, wrapperClassName)}>
            <input type={type} className={cn(styles.input, className)} {...props} />
        </div>
    );
}
